module.exports = __webpack_public_path__ + "img/hub-green.185d36b5.png";